// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";   
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD7Vd4CSCpgHwG8VuVUy-zQkRtEkyQCOy4",
  authDomain: "quickseva-c2876.firebaseapp.com",
  projectId: "quickseva-c2876",
  storageBucket: "quickseva-c2876.firebasestorage.app",
  messagingSenderId: "472200381486",
  appId: "1:472200381486:web:15297803079aef86f7cbbf",
  measurementId: "G-XRYN45RYX7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);